











import {Component, Vue, Prop} from "vue-property-decorator";
import {ChatMessages} from "../../../../../types/chat-messages";
import {Tool} from "../../../../helpers/Tool";
// @ts-ignore
import store from "../../../../store";

@Component({})

/**
 * Заголовок
 * В заголовок помещается название Раунда
 */
export default class SectionMessage extends Vue{
    @Prop({required: true}) private readonly message!: ChatMessages.Message;

    /**
     * Свернуть/развернуть секцию чата
     * @private
     */
    private toggleSectionVisibility(): void
    {
        if (this.message.parentId) {
            this.$emit('toggle-section-visibility', this.message.parentId);
        }
    }
}
